import _defaultsDeep from "lodash/defaultsDeep";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import PropTypes from 'prop-types';
import AcChart from 'react-apexcharts';
import { useTheme } from '@material-ui/core/styles';
import { ChartWrapper } from "../ChartWrapper/ChartWrapper";
import { NoData } from "../NoData/NoData";
import { useAfterMountingValue } from "../../hooks/useAfterMountingValue";

var _ref2 = /*#__PURE__*/_jsx(NoData, {});

const CommonCircularChart = _ref => {
  let type = _ref.type,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      colors = _ref.colors,
      _ref$showTotal = _ref.showTotal,
      showTotal = _ref$showTotal === void 0 ? false : _ref$showTotal,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  const theme = useTheme();
  const width = useAfterMountingValue('99%', '100%');

  if (!values.length) {
    return _ref2;
  }

  const props = {
    type,
    width,
    height: '100%',
    series: values.map(value => value.value),
    options: _defaultsDeep(options, {
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: type === 'donut' && showTotal,
              total: Object.assign(theme.typography.body2, {
                show: type === 'donut' && showTotal,
                showAlways: true,
                label: 'Total',
                formatter: _ref3 => {
                  let globals = _ref3.globals;
                  return globals && globals.seriesTotals.reduce((a, b) => a + b, 0);
                }
              })
            }
          }
        }
      },
      chart: {
        fontFamily: theme.typography.fontFamily,
        foreColor: theme.palette.text.primary,
        toolbar: {
          show: true,
          tools: {
            download: true
          }
        }
      },
      labels: values.map(value => value.label),
      dataLabels: {
        enabled: false
      },
      colors: colors || [theme.palette.primary.main, theme.palette.secondary.main, theme.palette.primary.dark, theme.palette.secondary.dark, theme.palette.primary.light, theme.palette.secondary.light],
      legend: {
        position: 'bottom',
        fontFamily: theme.typography.caption.fontFamily,
        horizontalAlign: 'center'
      },
      responsive: [{
        breakpoint: theme.breakpoints.values.sm,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
    })
  };
  return _jsx(ChartWrapper, {}, void 0, React.createElement(AcChart, props));
};

export { CommonCircularChart };